var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomDesktopImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 300,
    viewBox: "0 0 164 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.4263 72.8988L79.0158 64.2363L90.4211 66.111L94.921 76.8166V108.707L83.4579 116.427L75.2737 113.62L69.4263 101.219V72.8988Z",
    fill: "url(#paint0_linear_282_3518)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82 34.6309C37.8368 34.6783 2.04737 70.4868 2 114.674V207.354C2 251.562 37.8158 287.397 82 287.397C126.184 287.397 162 251.562 162 207.354V114.674C161.953 70.4868 126.163 34.6783 82 34.6309ZM90.4211 76.7585V102.035C90.4211 106.69 86.6526 110.461 82 110.461C77.3474 110.461 73.5789 106.69 73.5789 102.035V76.7585C73.5789 72.1034 77.3474 68.333 82 68.333C86.6526 68.333 90.4211 72.1034 90.4211 76.7585ZM10.4211 114.674C10.4842 76.7954 40 45.5156 77.7895 43.2723V60.5078C70.3737 62.4246 65.1842 69.1018 65.1579 76.7585V102.035C65.1842 109.697 70.3737 116.374 77.7895 118.286V135.737H10.4211V114.674ZM153.579 207.354C153.537 246.891 121.516 278.929 82 278.971C42.4842 278.929 10.4632 246.891 10.4211 207.354V144.163H153.579V207.354ZM153.579 135.737H86.2105V118.286C93.6263 116.369 98.8158 109.692 98.8421 102.035V76.7585C98.8158 69.0965 93.6263 62.4193 86.2105 60.5078V43.2723C124 45.5156 153.516 76.8006 153.579 114.674V135.737Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7303 13.5684L71.5221 16.3602C71.7034 16.5415 72.0007 16.5409 72.1828 16.3589L81.2959 7.24576C81.478 7.06372 81.7753 7.06319 81.9567 7.24455L91.0353 16.3232C91.2167 16.5045 91.514 16.504 91.6961 16.3219L94.4984 13.5196C94.6804 13.3375 94.681 13.0402 94.4996 12.8588L81.9698 0.328998C81.7884 0.147646 81.4911 0.148226 81.3091 0.330268L68.7316 12.9077C68.5496 13.0898 68.549 13.3871 68.7303 13.5684Z",
    fill: "url(#paint1_linear_282_3518)",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4816 165.788L91.6898 162.997C91.5085 162.815 91.2112 162.816 91.0291 162.998L81.916 172.111C81.7339 172.293 81.4366 172.294 81.2552 172.112L72.1766 163.034C71.9952 162.852 71.6979 162.853 71.5159 163.035L68.7135 165.837C68.5315 166.019 68.5309 166.317 68.7123 166.498L81.2421 179.028C81.4235 179.209 81.7208 179.209 81.9028 179.027L94.4803 166.449C94.6624 166.267 94.6629 165.97 94.4816 165.788Z",
    fill: "url(#paint2_linear_282_3518)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_3518",
    x1: 94.921,
    y1: 64.2363,
    x2: 92.7643,
    y2: 117.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#687D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE3E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_282_3518",
    x1: 94.6353,
    y1: 0.193359,
    x2: 94.429,
    y2: 16.8165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#687D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE3E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_282_3518",
    x1: 94.6173,
    y1: 162.861,
    x2: 94.4109,
    y2: 179.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#687D86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE3E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomDesktopImg);
export default __webpack_public_path__ + "static/media/zoom-desktop_img.00b4f635ec7dd10b72038d1b66369819.svg";
export { ForwardRef as ReactComponent };